
import React, { Fragment } from 'react';

// Components

import AddressItem from '../AddressItem';
import SummaryItem from '../SummaryItem';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';
import { phoneNumberTools } from '@utils/tools/phoneNumberTools';



const AuthorizedRepresentative = props => {
    
    const {
        customAddressItemProps,
        data,
        data: {
            authorizedRepresentativeIndicator,
            authorizedRepresentative: {
                address,
                companyName,
                name,
                organizationId,
                phone: authorizedRepresentativePhone,
                partOfOrganizationIndicator
            }
        },
        isState
    } = props;

    if (!authorizedRepresentativeIndicator) {
        return null;
    }

    const authRepTxt = isState.MN ? 'common.account_holder' : 'common.authorized_representative';

    const getAddressSecondLine = (city, state, postalCode) => {
        if(!city || !state || !postalCode) {
            return null;
        }

        return `${ city } ${ state }, ${ postalCode }`;
    };

    const getAuthRepresentativePhoneNumber = data => {
        const {
            authorizedRepresentative: {
                phone: authorizedRepresentativePhone
            }
        } = data;

        const authRepPhoneNumber = ['CELL', 'WORK', 'HOME']
            .reduce(
                (result, phoneType) => {

                    // Back-End tends to provide bad data. So, these checks are added to keep UI safe.

                    if(!Array.isArray(authorizedRepresentativePhone)) {
                        return null;
                    }

                    const phone = authorizedRepresentativePhone.find(ph => {
                        if(ph instanceof Object) {
                            const { phoneType: type, phoneNumber } = ph;
                            if(typeof type === 'string') {
                                return ph.phoneType.toLowerCase() === phoneType.toLowerCase()
                                    && phoneNumber;
                            }
                        }
                    });

                    if(!phone) {
                        return result;
                    } else {
                        const {
                            phoneNumber,
                            phoneExtension,
                        } = phone;
                        return result ? result : [ phoneNumber, phoneExtension, phoneType ];
                    }
                },
                null
            );

        const getFullNumberAsString = fullPhone => {
            if(Array.isArray(fullPhone)) {
                const [ phoneNumber, phoneExtension, phoneType ] = fullPhone;

                if(!phoneNumber) {
                    return null;
                }

                return `${phoneType? phoneType : ''} ${phoneNumberTools
                    .getAdjustedPhoneNumber(phoneNumber)} ${phoneExtension ? `ext. ${phoneExtension}` : ''}`;
            } else {
                return '';
            }
        };

        return getFullNumberAsString(authRepPhoneNumber);
    };
    
    return (
        <Fragment>
            <div className = 'grid-row'>
                <SummaryItem
                    textCode = { authRepTxt }
                    ignoreIntl
                    value = { normalizeNameOfPerson(name) }
                    desc = {
                        [
                            [
                                'authorizedRepresentative.name',
                                normalizeNameOfPerson
                            ]
                        ]
                    }
                />
            </div>
            {
                !isState.MN &&

                <Fragment>
                    <AddressItem
                        customAddressItemProps = { customAddressItemProps }
                        textCode = 'common.authorized_representative_home_address'
                        { ...address }
                        getAddressSecondLine = { getAddressSecondLine }
                        addressDescriptors = {
                            [
                                [
                                    [
                                        'authorizedRepresentative.address.streetAddress1'
                                    ]
                                ],
                                [
                                    [
                                        'authorizedRepresentative.address.streetAddress2'
                                    ]
                                ],
                                [
                                    [
                                        [
                                            'authorizedRepresentative.address.city',
                                            'authorizedRepresentative.address.state',
                                            'authorizedRepresentative.address.postalCode'
                                        ],
                                        getAddressSecondLine
                                    ]
                                ]
                            ]
                        }
                    />

                    {
                        authorizedRepresentativePhone.some(phone => phone.phoneNumber) &&

                        <div className = 'grid-row'>
                            <SummaryItem
                                textCode = 'common.representative_phone_number'
                                ignoreIntl
                                value = { getAuthRepresentativePhoneNumber(data) }
                                desc = {
                                    [
                                        [
                                            [
                                                'DATA'
                                            ],
                                            getAuthRepresentativePhoneNumber
                                        ]
                                    ]
                                }
                            />
                        </div>
                    }

                    {
                        partOfOrganizationIndicator &&

                            <div className = 'grid-row'>
                                <SummaryItem
                                    textCode = 'common.authorized_representative_organization_name'
                                    ignoreIntl
                                    value = { companyName }
                                    desc = {
                                        [
                                            [
                                                'authorizedRepresentative.companyName'
                                            ]
                                        ]
                                    }
                                />
                                <SummaryItem
                                    textCode = 'common.authorized_representative_organization_id'
                                    ignoreIntl
                                    value = { organizationId }
                                    desc = {
                                        [
                                            [
                                                'authorizedRepresentative.organizationId'
                                            ]
                                        ]
                                    }
                                />
                            </div>
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export default AuthorizedRepresentative;